import React, { Component } from 'react'
import {
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import LessonCard from "../LessonCard";
import EditNodes from "../EditNodes";

export default class SectionData extends Component {
  state = {
    displayName: "Challenger",
    name: "challenger",
    sectionParent: "ACT Mastery English",
    stars: 30,
    sectionStatus: true,
    showModalParent: false,
    showModalPublish: false,
    nodes: [
      { sectionId: "01", name: "Accomplish Purpose" },
      { sectionId: "01", name: "sdf" },
      { sectionId: "01", name: "sdsf" },
      { sectionId: "01", name: "Challenger" },
      { sectionId: "01", name: "mastery" },
      { sectionId: "01", name: "asd" },
      { sectionId: "01", name: "asdfsa" }
    ]
  };
  showDelete(node) {
    this.setState({ [node.name]: true });
  }
  hideDelete(node) {
    if (!this.state[`${node.name}-clicked`]) {
      this.setState({ [node.name]: false });
    }
  }
  handleClickAway(node) {
    this.setState({
      [`${node.name}-clicked`]: false,
      [node.name]: false
    });
  }

  changeParent = () => {
    console.log("Parent Changed")
    this.props.parentState({showModal: false})
  }

  togglePublish = () => {
    console.log("Published")
    this.props.parentState({showModal: false})
  }
  render() {
    let section = {
      id: '12321',
      name: 'challenger',
      displayName: 'Challenger',
      published: true
    }  
    return (
      <React.Fragment>
        <Col colSpan="6" md="6" sm="12">
          <LessonCard
            iconClass="info-lesson"
            heading="Lesson Data"
            isCollapsable={true}
          >
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Section Display Name: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  value={this.state.displayName}
                  onChange={e => {
                    this.setState({
                      displayName: e.target.value,
                      displayNameChanged: true
                    });
                  }}
                  onFocus={e => {
                    //console.log(e.target.value)
                    //this.setState({ displayNameChanged: true })
                  }}
                />
                {this.state.displayNameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ displayNameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Section Internal name: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  value={this.state.name}
                  onChange={e =>
                    this.setState({ name: e.target.value, nameChanged: true })
                  }
                />
                {this.state.nameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ nameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Stars Required: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input style={{width: '60px'}}
                  value={this.state.stars}
                  onChange={e =>
                    this.setState({ stars: e.target.value, starsChanged: true })
                  }
                />
                {this.state.starsChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ starsChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Section Parent: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>{this.state.sectionParent}</span>
                <span
                  className="modal-link"
                  onClick={() => this.props.showModal(section, `parent`, {confirmAction: this.changeParent})}
                >
                  Change Parent
                </span>
              </Col>
            </Row>

            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Section Status: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>
                  {this.state.sectionStatus ? "Published" : "Unpublished"}
                </span>
                <span
                  className="modal-link"
                  onClick={() => this.props.showModal(section, `publish`, {confirmAction: this.togglePublish})}
                >
                  {this.state.sectionStatus ? "Unpublish" : "Publish"}
                </span>
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Nodes: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                {this.state.nodes.map((node, index) => (
                  <div>
                    <div
                      className="node-name"
                      onMouseEnter={() => this.showDelete(node)}
                      onMouseLeave={() => this.hideDelete(node)}
                    >
                      {node.name}{" "}
                      {
                        <label
                          className={`delete-parent${
                            this.state[`${node.name}`] ? "-active" : ""
                          }`}
                          onClick={() =>
                            this.setState({ [`${node.name}-clicked`]: true })
                          }
                          onBlur={() => this.handleClickAway(node)}
                        >
                          <DeleteButton
                            handleDelete={() => console.log("Delete Node")}
                            index={index}
                          />
                        </label>
                      }
                    </div>
                  </div>
                ))}
                <div className="node-btn">
                  <Button
                    className="lesson-action-btn"
                    onClick={() => this.setState({ editNode: true })}
                  >
                    Edit Node
                  </Button>
                </div>
              </Col>
            </Row>
          </LessonCard>
        </Col>
        <Col colSpan="6" sm="12" md="6">
          {this.state.editNode && (
            <EditNodes type={'Subcourse'} name={'ACT Mastery English'}
              closeEditNode={() => this.setState({ editNode: false })}
              onUpdateNodes={nodes => this.setState({ nodes, editNode: false })}
            />
          )}
        </Col>
      </React.Fragment>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSection/SectionData.js